import { render, staticRenderFns } from "./addNewI.vue?vue&type=template&id=fc53e804&scoped=true"
import script from "./addNewI.vue?vue&type=script&lang=js"
export * from "./addNewI.vue?vue&type=script&lang=js"
import style0 from "./addNewI.vue?vue&type=style&index=0&id=fc53e804&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc53e804",
  null
  
)

export default component.exports